// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ColorValue, ViewProps } from 'react-native';
import type { DirectEventHandler, Int32, Double } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
type NativeSheetDetent = Readonly<{
  type: string;
  value: Double;
}>;
interface NativeProps extends ViewProps {
  isPresented: boolean;
  acknowledgedEvent: Int32;
  revision: Int32;
  presentationId: Int32;
  detents: ReadonlyArray<NativeSheetDetent>;
  fitToContents: boolean;
  selectedDetentType: string;
  selectedDetentValue: Double;
  acknowledgedDetentEvent: Int32;
  detentRevision: Int32;
  interactiveDismissDisabled: boolean;
  presentationDragIndicator: string;
  presentationBackground?: ColorValue;
  presentationBackgroundInteraction: string;
  presentationBackgroundInteractionDetentType: string;
  presentationBackgroundInteractionDetentValue: Double;
  presentationContentInteraction: string;
  presentationSizing: string;
  presentation: string;
  colorScheme: string;
  onNativeSheetIsPresentedChange?: DirectEventHandler<Readonly<{
    isPresented: boolean;
    eventCount: Int32;
    revision: Int32;
  }>>;
  onNativeSheetDismiss?: DirectEventHandler<Readonly<{
    revision: Int32;
  }>>;
  onNativeSheetDidDismiss?: DirectEventHandler<Readonly<{
    revision: Int32;
    presentationId: Int32;
  }>>;
  onNativeSheetDetentChange?: DirectEventHandler<Readonly<{
    type: string;
    value: Double;
    eventCount: Int32;
    revision: Int32;
  }>>;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  ConditionallyIgnoredEventHandlers
} = require('react-native/Libraries/NativeComponent/ViewConfigIgnore');
let nativeComponentName = 'OneNativeSheet';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeSheet",
  directEventTypes: {
    topNativeSheetIsPresentedChange: {
      registrationName: "onNativeSheetIsPresentedChange"
    },
    topNativeSheetDismiss: {
      registrationName: "onNativeSheetDismiss"
    },
    topNativeSheetDidDismiss: {
      registrationName: "onNativeSheetDidDismiss"
    },
    topNativeSheetDetentChange: {
      registrationName: "onNativeSheetDetentChange"
    }
  },
  validAttributes: {
    isPresented: true,
    acknowledgedEvent: true,
    revision: true,
    presentationId: true,
    detents: true,
    fitToContents: true,
    selectedDetentType: true,
    selectedDetentValue: true,
    acknowledgedDetentEvent: true,
    detentRevision: true,
    interactiveDismissDisabled: true,
    presentationDragIndicator: true,
    presentationBackground: require('react-native/Libraries/Components/View/ReactNativeStyleAttributes').colorAttribute,
    presentationBackgroundInteraction: true,
    presentationBackgroundInteractionDetentType: true,
    presentationBackgroundInteractionDetentValue: true,
    presentationContentInteraction: true,
    presentationSizing: true,
    presentation: true,
    colorScheme: true,
    ...ConditionallyIgnoredEventHandlers({
      onNativeSheetIsPresentedChange: true,
      onNativeSheetDismiss: true,
      onNativeSheetDidDismiss: true,
      onNativeSheetDetentChange: true
    })
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);